module.exports = __webpack_public_path__ + "static/media/pic5.567133bd.jpg";